import {
    parseNumber,
    receiveBoolean,
    receiveNumber,
    receiveObject,
    receiveString,
} from "../../../../controllers/adapters/receives"

const AutorizacionesAdapters = {

    // GET /integra-web/empresas/usuarios-autorizados/{empresaId}
    // Listado paginado de los usuarios autorizados en la empresa, con los datos de
    // `usuarios_ebcn` y `integra_personas_fisicas` unidos por NIF.
    // Parámetros: page, per_page, search, estado.
    // Respuesta: { status, message, code, data: PaginaBackendResponse }
    GET_USUARIOS_AUTORIZADOS: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    cliente_id: receiveNumber(item.cliente_id),
                    usuario_id: receiveNumber(item.usuario_id),
                    nombre: receiveString(item.nombre),
                    username: receiveString(item.username),
                    nif: receiveString(item.nif),
                    email: receiveString(item.email),
                    estado: receiveString(item.estado),
                    autorizada: receiveBoolean(item.estado === 'autorizada'),
                    authorized: receiveBoolean(item.authorized),
                    origen: receiveString(item.origen),
                    authorized_at: receiveString(item.authorized_at),
                    decision_at: receiveString(item.decision_at),
                }
            },

            adapter: function (data: any) {

                const paginator = data?.data?.data

                const items = (paginator?.elementos || []).map((item: any) => this.schema(item))

                return {
                    items,
                    numeroElementos: receiveNumber(paginator?.numeroElementos),
                    numeroPagina: receiveNumber(paginator?.numeroPagina),
                    numeroTotalElementos: receiveNumber(paginator?.numeroTotalElementos),
                    totalPages: receiveNumber(paginator?.totalPages),
                    numberOfElements: receiveNumber(paginator?.numberOfElements),
                    first: receiveBoolean(paginator?.first),
                    last: receiveBoolean(paginator?.last),
                    empty: receiveBoolean(paginator?.empty),
                }
            }
        },
    },

    // GET /integra-web/empresas/usuarios-autorizados/buscar
    // Candidatos a autorizar: usuarios de `usuarios_ebcn` sin autorización en la
    // empresa. Parámetros: q, empresa_id. Devuelve un array (máx. 10).
    GET_BUSCAR_PARA_AUTORIZAR: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    id: receiveNumber(item.id),
                    nif: receiveString(item.nif),
                    nombre: receiveString(item.first_name),
                    apellidos: receiveString(item.last_name),
                    email: receiveString(item.email),
                    username: receiveString(item.username),
                }
            },

            adapter: function (data: any) {

                const elementos = Array.isArray(data?.data?.data) ? data.data.data : []

                return {
                    items: elementos.map((item: any) => this.schema(item))
                }
            }
        },
    },

    // POST /integra-web/empresas/usuarios-autorizados
    // Autorización directa: no se envía correo, el alta queda como `autorizada`.
    // Request body: { empresa_id, usuario_id }
    // Respuesta:    { status: true, message, code, data }
    POST_AUTORIZAR_USUARIO: {

        send: {

            schema: function (item: any = {}) {

                return {
                    empresa_id: parseNumber(item.empresa_id),
                    usuario_id: parseNumber(item.usuario_id),
                }
            },

            adapter: function (data: any) {

                return {
                    ...this.schema(data)
                }
            }
        },

        receive: {

            schema: function (item: any = {}) {

                return {
                    status: receiveBoolean(item?.status),
                    message: receiveString(item?.message),
                    data: receiveObject(item?.data),
                }
            },

            adapter: function (data: any) {

                return this.schema(data?.data)
            }
        },
    },

    // DELETE /integra-web/empresas/usuarios-autorizados/{id}
    // Desvincula al usuario autorizado. El `id` es el de la autorización
    // (`integra_clientes_autorizaciones`), no el de la empresa ni el del usuario.
    // No lleva cuerpo: el backend no acepta nada en el `body`.
    DELETE_USUARIO_AUTORIZADO: {

        receive: {

            schema: function (item: any = {}) {

                return {
                    status: receiveBoolean(item?.status),
                    message: receiveString(item?.message),
                    data: receiveObject(item?.data),
                }
            },

            adapter: function (data: any) {

                return this.schema(data?.data)
            }
        },
    },
}

export {
    AutorizacionesAdapters,
}
